import {
  START_OR_RESUME_SURVEY_SUCCESS,
  COMMIT_QUESTION_BLOCK_SUCCESS,
  GET_BLOCK_SUCCESS,
  COMPLETE_SURVEY,
} from 'actionTypes';

const initialState = {
  currentQuestionBlockId: null,
  surveyComplete: false,
};

export default function currentQuestionBlockIdReducer(
  state = initialState,
  action
) {
  const { type, normalizedData } = action;
  switch (type) {
    case START_OR_RESUME_SURVEY_SUCCESS:
    case COMMIT_QUESTION_BLOCK_SUCCESS:
    case GET_BLOCK_SUCCESS:
      return {
        currentQuestionBlockId: normalizedData.result,
      };
    case COMPLETE_SURVEY:
      return {
        currentQuestionBlockId: null,
        surveyComplete: true,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/surveyReducer.js